"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI_NAMES = void 0;
var UI_NAMES = exports.UI_NAMES = {
  RATING_CONTROL_IN_SEARCH_FORM: 'RATING_CONTROL_IN_SEARCH_FORM',
  CATEGORY_CONTROL_IN_SEARCH_FORM: 'CATEGORY_CONTROL_IN_SEARCH_FORM',
  SERVICES_CONTROL_IN_SEARCH_FORM: 'SERVICES_CONTROL_IN_SEARCH_FORM',
  FOOD_CONTROL_IN_SEARCH_FORM: 'FOOD_CONTROL_IN_SEARCH_FORM',
  TOURISTS_CONTROL_IN_SEARCH_FORM: 'TOURISTS_CONTROL_IN_SEARCH_FORM',
  OPERATORS_CONTROL_IN_SEARCH_FORM: 'OPERATORS_CONTROL_IN_SEARCH_FORM',
  AVAILABILITY_CONTROL_IN_SEARCH_FORM: 'AVAILABILITY_CONTROL_IN_SEARCH_FORM',
  PHONE_CONTROL_IN_BOOKING_BY_OPERATOR_FORM: 'PHONE_CONTROL_IN_BOOKING_BY_OPERATOR_FORM',
  PAYER_EMAIL_CONTROL_IN_BOOKING_BY_OPERATOR_FORM: 'PAYER_EMAIL_CONTROL_IN_BOOKING_BY_OPERATOR_FORM',
  COMMENT_CONTROL_IN_BOOKING_BY_OPERATOR_FORM: 'COMMENT_CONTROL_IN_BOOKING_BY_OPERATOR_FORM'
};